import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xs-lib-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.css']
})
export class SwitchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
